import { render, staticRenderFns } from "./EzTax.vue?vue&type=template&id=b472a22a&"
import script from "./EzTax.vue?vue&type=script&lang=js&"
export * from "./EzTax.vue?vue&type=script&lang=js&"
import style0 from "./EzTax.vue?vue&type=style&index=0&id=b472a22a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports